import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.228 9.594c-.97-1.03-3.651-.612-4.28-.507a11 11 0 0 1-1.79-2.358c.357-.994.564-2.037.61-3.093 0-.943-.375-1.956-1.423-1.956a1.06 1.06 0 0 0-.882.515c-.446.769-.271 2.359.445 3.966-.42 1.18-1.022 2.883-1.817 4.263-1.074.428-3.354 1.476-3.573 2.638a.98.98 0 0 0 .315.926c.255.225.586.343.926.332 1.371 0 2.743-1.905 3.669-3.538a23 23 0 0 1 3.267-.856c1.45 1.266 2.743 1.459 3.398 1.459.89 0 1.223-.385 1.345-.708a1.09 1.09 0 0 0-.21-1.083m-.943.664c-.044.253-.367.506-.97.375a4.85 4.85 0 0 1-1.904-.96c.472-.08 1.572-.184 2.35-.035.28.052.603.21.524.62M7.03 2.527a.35.35 0 0 1 .306-.192c.332 0 .402.402.402.734-.054.791-.201 1.574-.437 2.332-.559-1.485-.48-2.516-.27-2.874m-.078 7.259q.485-1.018.865-2.079.524.83 1.188 1.555-1.041.207-2.053.524m-2.193 1.503c-.882 1.415-1.747 2.306-2.253 2.306a.36.36 0 0 1-.228-.079.33.33 0 0 1-.113-.323c.096-.507 1.1-1.24 2.594-1.904"
    }, null, -1)
  ])))
}
export default { render: render }